import Vue from 'vue'
import AmataDialog from './AmataDialog.vue'

const open = (propsData?: any) => {
  const AmataDialogComponent = Vue.extend(AmataDialog)
  return new AmataDialogComponent({
    el: document.createElement('div'),
    propsData
  })
}

export default {
  /**
   * アラートダイアログ
   */
  alert(params) {
    let message
    if (typeof params === 'string') {
      message = params
    }
    const defaultParams = {
      canCancel: false,
      message
    }
    params = { ...defaultParams, ...params }
    return open(params)
  },

  /**
   * 確認ダイアログ
   */
  confirm(params) {
    const defaultParams = {}
    params = { ...defaultParams, ...params }
    return open(params)
  },

  /**
   * 入力ダイアログ
   */
  prompt(params) {
    const defaultParams = {
      hasInput: true,
      confirmText: 'Done'
    }
    params = { ...defaultParams, ...params }
    return open(params)
  }
}
